import initMarquee from 'marquee';
import { clamp } from '@subs2025/utils';
import { state } from '@subs2025/state';
import { createStepHandlers } from '@subs2025/step-handlers';
import { setupQuantityPopup } from '@subs2025/quantity-popup';

function initSubsMarquee(){
	const marquee = document.querySelector('[data-subs-marquee]');
	if (!marquee) return;
	initMarquee(marquee);
}

// Create step handlers
const stepHandlers = createStepHandlers();

// Initialize quantity popup
setupQuantityPopup();

function initSubsProgress(){
	const progressBar = document.querySelector('[data-subs-progress-bar]');
	const progressBarBackButtons = Array.from(document.querySelectorAll('[data-subs-back-button]'));
	const progressBarNextButtons = Array.from(document.querySelectorAll('[data-subs-next-button]'));

	// Find steps in DOM order; each step has a key (data-subs-step-2025="<key>")
	const stepNodes = Array.from(document.querySelectorAll('[data-subs-step-2025]'));
	if (!stepNodes.length) return;

	// Update the step structure to include allowDirectAccess and routeType properties
	const steps = stepNodes.map(el => ({
		el,
		key: el.getAttribute('data-subs-step-2025') || '',
		routeType: el.getAttribute('data-route-type') || null,
		allowDirectAccess: el.getAttribute('data-allow-direct-access') === 'true' // defaults to false unless explicitly set to true
	}));

	const stepEls = stepNodes;

	let currentIndex = 0;
	updateCurrentRoute();

	// Function to update route based on checked input
	function updateCurrentRoute() {
		const checkedRouteInput = document.querySelector('[data-subs-route]:checked');
		console.log('checkedRouteInput', checkedRouteInput);
		if (checkedRouteInput) {
			state.currentRoute = checkedRouteInput.getAttribute('data-subs-route');
			console.log('Route updated to:', state.currentRoute);
			console.log('steps', getActiveSteps());
			updateProgressState();
		}
	}
	document.querySelectorAll('[data-subs-route]').forEach(input => {
		input.addEventListener('change', updateCurrentRoute);
	});

	// Get steps filtered by current route
	function getActiveSteps() {
		if (!state.currentRoute) {
			// No route selected: show only universal steps (no routeType)
			console.log('no route selected, showing universal steps');
			return steps.filter(s => !s.routeType);
		}
		// Route selected: show universal steps + steps matching current route
		return steps.filter(s => {
			if (!s.routeType) return true; // Universal step
			return s.routeType.split(/\s+/).includes(state.currentRoute); // Check if route matches
		});
	}

	function updateStepIndicator(progressBar, currentIndex, totalSteps){
		const stepIndicatorWrapper = progressBar.querySelector('[data-subs-progress-bar-step-indicator-wrapper]');

		const setupIndicators = () => {
			const template = progressBar.querySelector('[data-subs-progress-bar-step-indicator-template]');
			if (!template) return console.error('Subscription progress indicator template not found');
			stepIndicatorWrapper.innerHTML = '';

			for (let i = 0; i < totalSteps; i++) {
				const clone = template.content.cloneNode(true);
				stepIndicatorWrapper.appendChild(clone);
			}
		}

		const hasIndicators = () => {
			const indicators = progressBar.querySelectorAll('[data-subs-progress-bar-step-indicator]');
			return indicators.length === totalSteps;
		}

		if (!hasIndicators()) setupIndicators();

		const indicators = progressBar.querySelectorAll('[data-subs-progress-bar-step-indicator]');
		indicators.forEach((indicator, index) => {
			indicator.classList.toggle('active', index <= currentIndex);
		});

	}
	function updateProgressState(){
		const activeSteps = getActiveSteps();
		const total = activeSteps.length;
		document.documentElement.style.setProperty('--subs-total-steps', String(total));
		document.documentElement.style.setProperty('--subs-current-step', String(currentIndex + 1));
		if (progressBar) {
			progressBar.setAttribute('data-total-steps', String(total));
			progressBar.setAttribute('data-current-step', String(currentIndex + 1));

			const currentStepEl = progressBar.querySelector('[data-subs-current-step]');
			const totalStepsEl = progressBar.querySelector('[data-subs-total-steps]');
			if (currentStepEl) currentStepEl.textContent = String(currentIndex + 1);
			if (totalStepsEl) totalStepsEl.textContent = String(total);
			updateStepIndicator(progressBar, currentIndex, total);
		}
		if (progressBarBackButtons.length) {
			progressBarBackButtons.forEach(button => {
				button.disabled = currentIndex <= 0;
			});
		}


		const isLastStep = currentIndex === activeSteps.length - 1;
		progressBarNextButtons.forEach(button => {
			button.classList.toggle('hidden', isLastStep);
		});

		// Set current step attribute on the active section
		activeSteps.forEach((step, idx) => {
			if (idx === currentIndex) {
				step.el.setAttribute('data-current-step', 'true');
			} else {
				step.el.removeAttribute('data-current-step');
			}
		});
	}

	function runInitFor(index){
		const activeSteps = getActiveSteps();
		if (!activeSteps[index]) return;
		const handler = stepHandlers[activeSteps[index].key];
		if (handler && typeof handler.init === 'function') {
			try { 
				handler.init({ stepEl: activeSteps[index].el, index, steps: stepEls }); 
			} catch(e) {
				console.error('Error initializing step', activeSteps[index].key, e);

			}
		}
	}

	function showStep(i){
		console.log('showStep', i);
		const activeSteps = getActiveSteps();
		const nextIndex = clamp(i, 0, activeSteps.length - 1);

		// Hide all steps first
		steps.forEach(s => s.el.classList.remove('active'));

		// Show only the active step from filtered array
		if (activeSteps[nextIndex]) {
			activeSteps[nextIndex].el.classList.add('active');
		}

		currentIndex = nextIndex;
		runInitFor(currentIndex);
		try { history.replaceState(null, '', '#step=' + activeSteps[currentIndex].key); } catch(e) {}
		updateProgressState();
	}

	function goNext(){
		// Update route before getting active steps (in case we're on subscription-gate)
		updateCurrentRoute();

		const activeSteps = getActiveSteps();
		if (!activeSteps[currentIndex]) return;

		const handler = stepHandlers[activeSteps[currentIndex].key];
		if (handler && typeof handler.validate === 'function') {
			const valid = handler.validate({ stepEl: activeSteps[currentIndex].el, index: currentIndex, steps: stepEls });
			if (!valid) return;
		}
		if (handler && typeof handler.next === 'function') {
			const res = handler.next({ stepEl: activeSteps[currentIndex].el, index: currentIndex, steps: stepEls });
			if (res?.redirect) {
				 window.location.assign(res.redirect); return;
				}
			if (typeof res?.goTo === 'number') { history.pushState(null, '', '#step=' + activeSteps[res.goTo].key); showStep(res.goTo); return; }
			if (res === false || res?.stop) return;
		}
		if (currentIndex < activeSteps.length - 1) showStep(currentIndex + 1);
	}

	function goBack(){
		const activeSteps = getActiveSteps();
		if (!activeSteps[currentIndex]) return;

		const handler = stepHandlers[activeSteps[currentIndex].key];
		if (handler && typeof handler.back === 'function') {
			const res = handler.back({ stepEl: activeSteps[currentIndex].el, index: currentIndex, steps: stepEls });
			if (typeof res?.goTo === 'number') { history.pushState(null, '', '#step=' + activeSteps[res.goTo].key); showStep(res.goTo); return; }
		}
		if (currentIndex > 0) showStep(currentIndex - 1);
	}

	progressBarNextButtons.forEach(button => {
		button.addEventListener('click', goNext);
	});
	progressBarBackButtons.forEach(button => {
		button.addEventListener('click', goBack);
	});
	document.addEventListener('subs-next-step', goNext);
	document.addEventListener('subs-back-step', goBack);

	// Support key-based hashes only
	function indexFromHash(){
		const hashParams = new URLSearchParams(location.hash.slice(1));
		const stepKey = hashParams.get('step');
		if (!stepKey) return -1;

		const activeSteps = getActiveSteps();
		const targetIndex = activeSteps.findIndex(s => s.key === stepKey);
		if (targetIndex === -1) return -1;

		// Check if step allows direct access
		if (!activeSteps[targetIndex].allowDirectAccess) {
			console.warn(`Step "${stepKey}" cannot be accessed directly via URL. Redirecting to last valid step.`);

			// Find the last step that allows direct access
			const lastValidStep = findLastValidStep(targetIndex);
			if (lastValidStep !== -1) {
				// Update URL to redirect to the last valid step
				history.replaceState(null, '', '#step=' + activeSteps[lastValidStep].key);
				return lastValidStep;
			}

			// If no valid step found, start from beginning
			return 0;
		}

		return targetIndex;
	}

	// Find the last step that allows direct access before the target step
	function findLastValidStep(targetIndex) {
		const activeSteps = getActiveSteps();
		// Look backwards from target step to find last accessible step
		for (let i = targetIndex - 1; i >= 0; i--) {
			if (activeSteps[i].allowDirectAccess) {
				return i;
			}
		}
		return -1; // No valid step found
	}

	window.addEventListener('popstate', () => {
		const target = indexFromHash();
		if (target !== -1 && target !== currentIndex) showStep(target);
	});

	const start = indexFromHash();
	showStep(start ?? 0);
}
initSubsProgress();

initSubsMarquee();